export const API_PATH = '/~/api'
export const API_UPLOADS_PATH = API_PATH + '/uploads'
export const UPLOADS_CACHE_NAME = 'app-uploads-cache';
export const CACHE_UPLOAD_MESSAGE_TYPE = 'cache-uploads';
